import { useState } from "react";
import { motion } from "framer-motion";
import { useLang } from "../App";
import { IMAGES } from "../images";
import Reveal, { Overline, EASE } from "./Reveal";

export default function Expertise() {
  const { t } = useLang();
  const [active, setActive] = useState(-1);

  return (
    <section id="expertise" data-testid="expertise-section" className="relative bg-ink px-6 py-28 text-ivory md:px-12 md:py-40 lg:px-20">
      <Reveal>
        <Overline dark>{t.expertise.label}</Overline>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-10 font-serif text-4xl font-medium sm:text-5xl lg:text-6xl">{t.expertise.headline}</h2>
      </Reveal>

      <div className="relative mt-20">
        <div className="lg:max-w-[62%]">
          {t.expertise.items.map((item, i) => (
            <Reveal key={item.num} delay={i * 0.08}>
              <div
                data-testid={`expertise-row-${i + 1}`}
                onMouseEnter={() => setActive(i)}
                onMouseLeave={() => setActive(-1)}
                className="group cursor-default border-t border-ivory/12 py-10 transition-colors duration-500 last:border-b md:py-14"
              >
                <div className="flex flex-col gap-5 md:flex-row md:items-baseline md:gap-12">
                  <span className="font-serif text-sm italic text-bronze md:text-base">{item.num}</span>
                  <h3 className="text-3xl font-light uppercase tracking-[0.18em] text-ivory transition-colors duration-500 group-hover:text-champagne sm:text-4xl lg:text-5xl">
                    {item.title}
                  </h3>
                  <p className="max-w-sm text-sm font-light leading-relaxed text-ivory/55 md:ml-auto">
                    {item.text}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="pointer-events-none absolute right-0 top-1/2 hidden h-[440px] w-[340px] -translate-y-1/2 lg:block xl:w-[380px]" data-testid="expertise-image-panel">
          {IMAGES.expertise.map((src, i) => (
            <motion.div
              key={src}
              initial={false}
              animate={{ opacity: active === i ? 1 : 0, scale: active === i ? 1 : 1.06 }}
              transition={{ duration: 0.8, ease: EASE }}
              className="absolute inset-0 overflow-hidden"
            >
              <img src={src} alt="" className="h-full w-full object-cover" loading="lazy" />
              <div className="absolute inset-0 bg-ink/20" />
            </motion.div>
          ))}
          <div className="absolute -bottom-px -left-px h-16 w-px bg-bronze" />
          <div className="absolute -bottom-px -left-px h-px w-16 bg-bronze" />
        </div>
      </div>
    </section>
  );
}
